// extracted by mini-css-extract-plugin
module.exports = {"product-list":"ProductsList_product-list__1dte9","actions":"ProductsList_actions__1aG78","active":"ProductsList_active__1TKNo"};